import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const DynamicTitle = () => {
  const location = useLocation()
  const { section } = useSelector((state) => state.sectionSlice)
  let title = 'centelHR'

  if (location?.pathname === '/') {
    title = 'centelHR login - Payroll, HR, Spend | centelHR'
  } else if (location?.pathname === '/register') {
    title = 'centelHR register - Payroll, HR, Spend | centelHR'
  } else if (section?.name) {
    const formattedName =
      section.name.toLowerCase() === 'core hr'
        ? 'Core HR'
        : section.name.charAt(0).toUpperCase() + section.name.slice(1)
    title = `centelHR - ${formattedName}`
  }

  useEffect(() => {
    document.title = title
  }, [title])

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}

export default DynamicTitle
